import * as deliveryBatches from './deliveryBatches';
import * as deliveryTasks from './deliveryTasks';
import * as taskBank from './taskBank';

export default {
  deliveryBatches,
  deliveryTasks,
  taskBank,
};
